import { InternalThemeConfig } from "../../config";
import { ComponentsOverrides, Theme } from "@mui/material";

const checkbox = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiCheckbox"] => ({
    root: {
        color: undefined,
    },
    colorPrimary: {
        color: palette.white,
        border: `0.1rem solid ${palette.grey30}`,
        borderRadius: spacing(0.5),
        width: spacing(3),
        height: spacing(3),
        padding: 0,
        margin: spacing(0.25),

        "&:hover, &.Mui-checked": {
            width: spacing(3.5),
            height: spacing(3.5),
            margin: 0,
            borderWidth: spacing(0.25),
            borderStyle: "solid",
        },
        "&:hover": {
            borderColor: palette.lightPrimary,
            "@media (hover: none)": {
                borderColor: palette.grey30,
            },
        },
        "&.Mui-checked": {
            color: palette.white,
            borderColor: palette.lightPrimary,
            backgroundColor: palette.lightPrimary,
            "&:hover": {
                borderColor: palette.primary,
                backgroundColor: `${palette.primary}`,
            },
            "@media (hover: none)": {
                "&:hover": {
                    borderColor: palette.lightPrimary,
                    backgroundColor: palette.lightPrimary,
                },
            },
        },
        "&.Mui-disabled": {
            color: undefined,
            border: `0.2rem solid ${palette.grey40}`,
        },
        "&.Mui-disabled.Mui-checked": {
            backgroundColor: palette.grey40,
            borderColor: palette.grey40,
        },
    },
});

export default checkbox;
